import React from 'react';

type CollapseButtonProps = {
  onClick: () => void;
};

export function CollapseButton({ onClick }: CollapseButtonProps) {
  return (
    <button
      onClick={onClick}
      className="iconCircle iconCircle--outline sidebarNav-collapse"
    >
      <span className="svgIcon svgIcon--stroked primary100">
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path d="m16 20-8-8 8-8" />
        </svg>
      </span>
    </button>
  );
}
